import React from "react";

interface CurrencyInputProps {
    label: string;
    name: string;
    value: string | number;
    currency?: string;
    error?: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({
    label,
    name,
    value,
    currency = "NGN",
    error,
    onChange,
}) => {
    return (
        <div>
            <label className="block text-sm font-semibold mb-1">{label}</label>
            <div className="flex items-center mt-2 relative">
                <span className="absolute left-0 top-1/2 -translate-y-1/2 text-3xl font-medium pl-1">
                    ₦
                </span>
                <input
                    type="number"
                    name={name}
                    placeholder="0.00"
                    value={value}
                    onChange={onChange}
                    className={`w-full pl-8 pr-20 bg-transparent border-0 border-b-2 
            ${error ? "border-red-400 focus:border-red-500" : "border-gray-200 focus:border-primary-400"} 
            rounded-none py-2 text-3xl font-medium focus:outline-none transition placeholder-gray-300`}
                    style={{ letterSpacing: "1px" }}
                />
                <select
                    name="currency"
                    value={currency}
                    onChange={onChange}
                    className="absolute right-0 top-1/2 -translate-y-1/2 bg-transparent border-0 text-gray-500 text-base font-medium pr-2 focus:outline-none cursor-pointer"
                    style={{ minWidth: "60px" }}
                >
                    <option value="NGN">NGN</option>
                </select>
            </div>
            {error && <span className="text-xs text-red-500">{error}</span>}
        </div>
    );
};

export default CurrencyInput;
